import {
  AfterSubmitFunc, Button, ButtonColor, ButtonSize, ButtonVariant,
  FormTemplate,
  useMassUpdateServiceRequired,
  useShowContextRequired
} from 'ui-builder';
import { Plan } from 'nekst-api';
import { useCopyTasksService } from './copyTasksService';
import { CopyPlanTasksToggleWrapper } from 'feature-toggle';
import React from 'react';

import { usePopupFormManager } from 'features/nekst-widgets';
import { GlobalPlansMultiDropdown } from 'features/tasks-forms';


function CopyTasksForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const massUpdateService = useMassUpdateServiceRequired();

  const showContext = useShowContextRequired<Plan>();

  const sourcePlanId = showContext.data!.id;

  const copyTasksService = useCopyTasksService();
  return (
    <FormTemplate<{targetPlansIds: number[]}>
      submitFormFunc={async (data) => {
        const tasksIds = massUpdateService.getCheckedIds();

        await copyTasksService.copyTasks({
          sourcePlanId,
          targetPlansIds: data.targetPlansIds,
          tasksIds,
        });

        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={{
        targetPlansIds: {
          type: 'array',
          constraints: {
            required: true,
          }
        }
      }}
      title="Copy Tasks"
    >
      <GlobalPlansMultiDropdown
        source="targetPlansIds"
        label="Please select one or more Workflows to copy these tasks to:"
        hint="In case the dependent task is selected, all parent tasks will be copied as well"
        exceptPlansIds={[sourcePlanId]}
      />
    </FormTemplate>
  );
}

export function CopyTasksToGlobalPlansButton() {
  const popupFormManager = usePopupFormManager();

  const massUpdateService = useMassUpdateServiceRequired();

  const ids = massUpdateService.getCheckedIds();

  return (
    <CopyPlanTasksToggleWrapper>
      <Button
        text="Copy"
        isDisabled={ids.length === 0}
        onClick={async () => {
          popupFormManager.openForm(<CopyTasksForm />);
        }}
        color={ButtonColor.GRAY}
        size={ButtonSize.SMALL}
        isFlat
        variant={ButtonVariant.FILLED}
      />
    </CopyPlanTasksToggleWrapper>
  );
}
